import React, { useEffect, useState } from 'react';
import { getStaff } from '../api';

export default function StepStaff({ slug, serviceId, onSelect }) {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getStaff(slug, serviceId)
      .then(setStaff)
      .catch(() => setError('Failed to load staff.'))
      .finally(() => setLoading(false));
  }, [slug, serviceId]);

  if (loading) return (
    <div className="w-loading">
      <div className="w-spinner" />
      <span>Loading staff…</span>
    </div>
  );

  if (error) return <div className="w-error">{error}</div>;

  return (
    <>
      <div className="w-title">Choose a staff member</div>
      <div className="w-list">
        <button className="w-card w-any-card" onClick={() => onSelect(null)}>
          <div className="w-card-avatar" style={{ background: '#94a3b8', fontSize: 18 }}>✦</div>
          <div className="w-card-body">
            <div className="w-card-name">Any available</div>
            <div className="w-card-meta">We'll assign the next available person</div>
          </div>
        </button>
        {staff.map(s => (
          <button key={s.id} className="w-card" onClick={() => onSelect(s)}>
            <div
              className="w-card-avatar"
              style={{ background: s.color || 'var(--primary)' }}
            >
              {s.name.charAt(0).toUpperCase()}
            </div>
            <div className="w-card-body">
              <div className="w-card-name">{s.name}</div>
              {s.title && <div className="w-card-meta">{s.title}</div>}
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
